import CheckboxWithLabel from "./CheckboxWithLabel";

export default CheckboxWithLabel;
